var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.64,5.24l-4.19,4.2-.24.48,0,4,.17.5,4.29,4.35L22,18.19V5.81ZM18,13.53V10.47l2.14-2.14v7.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.92,5.32H5A3.28,3.28,0,0,0,2,8.78v6.41a3.3,3.3,0,0,0,3.05,3.49h6.86a3.29,3.29,0,0,0,3-3.45V8.81A3.29,3.29,0,0,0,11.92,5.32Zm1.18,9.93a1.37,1.37,0,0,1-1.22,1.45H5.09a1.38,1.38,0,0,1-1.25-1.48V8.75A1.37,1.37,0,0,1,5.06,7.3h6.79A1.38,1.38,0,0,1,13.1,8.78v6.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.68,8.35a1.37,1.37,0,1,0,1.37,1.37A1.37,1.37,0,0,0,10.68,8.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.68,12.91a1.37,1.37,0,1,0,1.37,1.37A1.37,1.37,0,0,0,10.68,12.91Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/camera-on.07f8b566e7da4a4e3cfae40474d27d50.svg";
export { ForwardRef as ReactComponent };